import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {AvtaleModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";
const debug: Debugger = require('debug')('AvtaleAdministrasjonKontroller');

const css = require('./administrasjon.scss');


export class AvtaleAdministrasjonKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmAvtaleAdministrasjon', {
                bindings: {avtale: '<'},
                controller: AvtaleAdministrasjonKontroller.forInjisering(),
                template: require('./administrasjon.html')
            });
    }

    static forInjisering() {
        return [
            AvtaleAdministrasjonKontroller
        ]
    }

    constructor() {
    }

    avtale: l.AvtaleModell; //settes via bindings/$onChanges

    avtaleNg2: AvtaleModell;

    private init(avtale:l.AvtaleModell){
        this.avtaleNg2 = kopierFraAjsTilNg2(avtale);
    }

    $onChanges(endringer: IOnChangesObject): void {
        debug('$onChanges', endringer);
        dersomChangesInneholder(endringer, 'avtale', avtale => this.init(avtale));
    }

}

